var _g, _g2, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.74657,
    y: -1.3745,
    width: 20.122,
    height: 20.124
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_0_18165_16109_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_18165_16109)",
    "data-figma-bg-blur-radius": 4.08153
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0577 8.67753C12.8774 8.46952 12.6139 8.35165 12.3435 8.35165H9.86136C8.64107 8.35165 7.64958 7.36017 7.64958 6.13988V3.6577C7.64958 3.38729 7.53172 3.12382 7.32371 2.94355C7.12264 2.76328 6.8453 2.68008 6.58183 2.71475C4.95247 2.92275 3.45484 3.81717 2.47722 5.16226C1.49267 6.51429 1.13213 8.16445 1.44413 9.81462C1.89481 12.1997 3.80151 14.1064 6.19356 14.5571C6.5749 14.6334 6.95624 14.668 7.33758 14.668C8.59254 14.668 9.80589 14.2798 10.839 13.524C12.1841 12.5464 13.0785 11.0488 13.2865 9.41941C13.3212 9.149 13.238 8.8786 13.0577 8.67753Z",
    fill: "url(#paint0_linear_18165_16109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0577 8.67753C12.8774 8.46952 12.6139 8.35165 12.3435 8.35165H9.86136C8.64107 8.35165 7.64958 7.36017 7.64958 6.13988V3.6577C7.64958 3.38729 7.53172 3.12382 7.32371 2.94355C7.12264 2.76328 6.8453 2.68008 6.58183 2.71475C4.95247 2.92275 3.45484 3.81717 2.47722 5.16226C1.49267 6.51429 1.13213 8.16445 1.44413 9.81462C1.89481 12.1997 3.80151 14.1064 6.19356 14.5571C6.5749 14.6334 6.95624 14.668 7.33758 14.668C8.59254 14.668 9.80589 14.2798 10.839 13.524C12.1841 12.5464 13.0785 11.0488 13.2865 9.41941C13.3212 9.149 13.238 8.8786 13.0577 8.67753Z",
    fill: "url(#paint1_linear_18165_16109)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.512406,
    y: -5.47432,
    width: 21.9916,
    height: 21.9799
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_1_18165_16109_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_18165_16109)",
    "data-figma-bg-blur-radius": 6.2751
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8775 5.67261C14.2476 3.53663 12.4659 1.755 10.33 1.12503C8.70582 0.652557 7.58369 0.69193 6.80608 1.27268C5.87097 1.97155 5.7627 3.23149 5.7627 4.12722V6.57819C5.7627 8.99962 6.86514 10.23 9.03065 10.23H11.8557C12.7415 10.23 14.0113 10.1218 14.7102 9.18664C15.3106 8.41887 15.3598 7.29674 14.8775 5.67261Z",
    fill: "url(#paint2_linear_18165_16109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99414 1.52441C7.64821 1.03596 8.64193 0.96029 10.2422 1.42578C12.2756 2.02584 13.9764 3.72818 14.5762 5.76172H14.5771C15.0519 7.36049 14.9656 8.3503 14.4629 8.99316L14.459 8.99902C14.1635 9.39435 13.7406 9.62503 13.2686 9.75684C12.7942 9.88928 12.2888 9.91602 11.8555 9.91602H9.03027C8.00708 9.91594 7.28771 9.62685 6.81836 9.10254C6.34332 8.57173 6.07617 7.74713 6.07617 6.57812V4.12695C6.0762 3.22405 6.19609 2.12089 6.99414 1.52441Z",
    stroke: "url(#paint3_linear_18165_16109)",
    strokeWidth: 0.627513
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18165_16109",
    x: -2.74657,
    y: -1.3745,
    width: 20.122,
    height: 20.124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.566879,
    dy: 0.566879
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28344
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18165_16109"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_18165_16109_clip_path",
    transform: "translate(2.74657 1.3745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0577 8.67753C12.8774 8.46952 12.6139 8.35165 12.3435 8.35165H9.86136C8.64107 8.35165 7.64958 7.36017 7.64958 6.13988V3.6577C7.64958 3.38729 7.53172 3.12382 7.32371 2.94355C7.12264 2.76328 6.8453 2.68008 6.58183 2.71475C4.95247 2.92275 3.45484 3.81717 2.47722 5.16226C1.49267 6.51429 1.13213 8.16445 1.44413 9.81462C1.89481 12.1997 3.80151 14.1064 6.19356 14.5571C6.5749 14.6334 6.95624 14.668 7.33758 14.668C8.59254 14.668 9.80589 14.2798 10.839 13.524C12.1841 12.5464 13.0785 11.0488 13.2865 9.41941C13.3212 9.149 13.238 8.8786 13.0577 8.67753Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_18165_16109",
    x: -0.512406,
    y: -5.47432,
    width: 21.9916,
    height: 21.9799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18165_16109"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18165_16109",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.871542,
    dy: 0.871542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.435771
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_18165_16109"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_18165_16109_clip_path",
    transform: "translate(0.512406 5.47432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8775 5.67261C14.2476 3.53663 12.4659 1.755 10.33 1.12503C8.70582 0.652557 7.58369 0.69193 6.80608 1.27268C5.87097 1.97155 5.7627 3.23149 5.7627 4.12722V6.57819C5.7627 8.99962 6.86514 10.23 9.03065 10.23H11.8557C12.7415 10.23 14.0113 10.1218 14.7102 9.18664C15.3106 8.41887 15.3598 7.29674 14.8775 5.67261Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18165_16109",
    x1: 7.6837,
    y1: 2.70703,
    x2: -2.1779,
    y2: 14.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18165_16109",
    x1: 7.6837,
    y1: 2.70703,
    x2: 10.5685,
    y2: 16.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18165_16109",
    x1: 10.4833,
    y1: 0.800781,
    x2: 2.64156,
    y2: 9.64119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18165_16109",
    x1: 17.6018,
    y1: 9.60078,
    x2: 9.15175,
    y2: 11.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.942004a73ee4206f9cdeb2f8f5524cf5.svg";
export { ForwardRef as ReactComponent };